import { Entity, PrimaryGeneratedColumn, Column, OneToMany } from 'typeorm';
import { IsOptional, IsInt, IsString } from 'class-validator';
import { Usuario } from './Usuario';
  
@Entity({name: "grupos"})
export class Grupo {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsString()
  nome: string;

  @Column()
  @IsString()
  alias: string;

  // RELATIONS
  @OneToMany(type => Usuario, usuarios => usuarios.grupo)
  usuarios?: Usuario[];
}
  